import { DataTableColumnHeader } from '@/components/dataTable/ColumnHeader';
import { getSerialNumber } from '@/components/dataTable/data-table.utils';
import { formatDate } from '@/lib/dateFormatter';
import { StorePerformance } from '@/services/dashboard/conversionAnalytics/conversionAnalytics.types';
import type { ColumnDef } from '@tanstack/react-table';

export function getColumns(t: (key: string) => string): ColumnDef<StorePerformance>[] {
  return [
    {
      accessorKey: 'sn',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('common.page.tableColumn.sn') || 'S.N'} />
      ),
      cell: ({ row, table }) => (
        <div className="font-semibold text-xs text-foreground-detail truncate max-w-[4rem]">
          {getSerialNumber(table, row.index)}
        </div>
      ),
      enableSorting: false,
      enableHiding: false,
    },
    {
      accessorKey: 'storeName',
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t('common.page.tableColumn.storeName') || 'Store Name'}
          className="whitespace-nowrap"
        />
      ),
      cell: ({ row }) => (
        <div className="max-w-[15rem] truncate whitespace-pre text-xs font-semibold text-foreground-heading">
          {row.original.storeName}
          {row.original.locationName ? `  ${row.original.locationName}` : null}
        </div>
      ),
      enableHiding: false,
      enableSorting: true,
    },
    {
      accessorKey: 'reservationStore',
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t('common.page.tableColumn.reservationStore') || 'Reservation Store'}
          className="whitespace-nowrap"
        />
      ),
      cell: ({ row }) => (
        <div className="font-medium text-xs text-foreground-detail">{row.getValue('reservationStore')}</div>
      ),
      enableHiding: false,
      enableSorting: true,
    },
    {
      accessorKey: 'hostDetails',
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t('common.page.tableColumn.hostDetails') || 'Host Details'}
          className="whitespace-nowrap"
        />
      ),
      cell: ({ row }) => (
        <div className="font-medium text-xs text-foreground-detail">{row.getValue('hostDetails')}</div>
      ),
      enableHiding: false,
      enableSorting: true,
    },
    {
      accessorKey: 'phoneStore',
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t('common.page.tableColumn.phoneStore') || 'Phone Store'}
          className="whitespace-nowrap"
        />
      ),
      cell: ({ row }) => <div className="font-medium text-xs text-foreground-detail">{row.getValue('phoneStore')}</div>,
      enableHiding: false,
      enableSorting: true,
    },
    {
      accessorKey: 'phoneHost',
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t('common.page.tableColumn.phoneHost') || 'Phone Host'}
          className="whitespace-nowrap"
        />
      ),
      cell: ({ row }) => <div className="font-medium text-xs text-foreground-detail">{row.getValue('phoneHost')}</div>,
      enableHiding: false,
      enableSorting: true,
    },
    {
      accessorKey: 'totalClick',
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t('common.page.tableColumn.totalClicks')}
          className="whitespace-nowrap"
        />
      ),
      cell: ({ row }) => (
        <div className="font-semibold text-xs text-foreground-heading">{row.getValue('totalClick')}</div>
      ),
      enableHiding: false,
      enableSorting: true,
    },
    {
      id: 'createdDate',
      accessorKey: 'createdDate',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Date" />,
      cell: ({ row }) => (
        <div className="font-medium text-xs text-foreground-detail">
          {formatDate(row.getValue('createdDate'), 'YYYY/MM/DD')}
        </div>
      ),
      meta: {
        label: 'Date',
      },
      enableColumnFilter: true,
      enableHiding: false,
      enableSorting: true,
    },
  ];
}
